import React from "react";
import { Chip, Typography, Box, ChipProps, styled } from "@mui/material";
import { format } from "date-fns";

const CustomChip = styled(Chip)(({ theme }) => ({
  height: "auto",
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  "& .MuiChip-label": {
    display: "block",
    whiteSpace: "normal",
  },
  overflowWrap: "break-word",
  width: "fit-content",
}));

interface Message {
  alignment: "left" | "right";
  content: string;
  timestamp: string;
}

type ChatBubbleProps = {
  message: Message;
} & ChipProps;

const ChatBubble: React.FC<ChatBubbleProps> = ({ message, ...props }) => {
  return <CustomChip label={message.content} {...props} />;
};

export default ChatBubble;
